// src/components/WhatWillBeLearned.js
import React from "react";
import { Box, Center, Text, UnorderedList, ListItem } from "@chakra-ui/react";
import { Colors } from "../../../../static/static";
import whatWillBeLearnedData from "../../../../data/whatWillBeLearned.json";

function WhatWillBeLearned() {
  const data = whatWillBeLearnedData;

  return (
    <Center>
      <Box
        className="what-will-be-learned-container"
        width="100%"
        height={{  xs: '100vh', s: '85vh', md: "82vh", lg: "65vh", xl: "45vh" }}
        bgColor={Colors.bgBlue}
        objectFit="cover"
        bgPosition={{ md: "center" }}
        bgRepeat="no-repeat"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          textAlign="center"
          dir="rtl"
          bg={Colors.bgText}
          width={{ base: "90%", md: "55%" }}
          padding={6}
        >
          <Text fontSize={{ base: "1.3rem", md: "4.5vh" }} color={Colors.heading} mb={4} fontWeight={600}>
            {data.title}
          </Text>
          <UnorderedList textAlign="right" spacing={3}>
            {data.points.map((point) => (
              <ListItem key={point.id} fontSize={{ base: "0.9rem", md: "2vh" }}>
                {point.text}
              </ListItem>
            ))}
          </UnorderedList>
        </Box>
      </Box>
    </Center>
  );
}

export default WhatWillBeLearned;
